import React from "react";

import Loading from "components/Loading";

import classes from "./styles.module.scss";

const AnalysisIsRunning = ({ loadingText = "Analysis is running..." }) => {
    return (
        <div className={classes.analysisIsRunningContainer}>
            <h3>{loadingText}</h3>
            <Loading />
        </div>
    );
};

export default AnalysisIsRunning;
